import styled from 'styled-components';

export const Container = styled.div`
  background-color: #c5eaff;
  padding: 95px 0;

  p,
  strong,
  label,
  button {
    font-family: 'Inter', sans-serif;
  }

  @media (max-width: 768px) {
    padding: 60px 0;
  }

  @media (max-width: 575.98px) {
    padding: 40px 0;
  }
`;

export const Content = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const ContainerSections = styled.div`
  display: flex;
  justify-content: space-between;

  @media (min-width: 769px) {
    gap: clamp(12px, 1.5vw, 20px);
    flex-wrap: nowrap;
    overflow: visible;
  }

  @media (max-width: 768px) {
    overflow-x: auto;
    justify-content: flex-start;
    padding-bottom: 10px;

    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }

    > div {
      flex: 0 0 auto;
    }
  }
`;

export const ContentItem = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  p {
    color: #0015c1;
    margin: 0;
  }

  @media (min-width: 769px) {
    flex: 1;
    gap: clamp(6px, 0.8vw, 12px);

    img {
      flex-shrink: 0;
      width: clamp(50px, 6vw, 90px);
      height: auto;
    }

    .label {
      font-size: clamp(12px, 1.1vw, 18px);
      line-height: 1.3;
    }

    .destaque {
      font-weight: 400;
      font-size: clamp(28px, 40px, 56px);
      line-height: 1.1;
      white-space: nowrap;
    }
  }

  @media (max-width: 768px) {
    min-width: 173px;
    max-width: 250px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    img {
      width: 79px;
      height: 48px;
    }

    .label {
      font-size: 14px;
    }

    .destaque {
      font-size: 32px;
      font-weight: 400;
    }
  }

  @media (max-width: 575.98px) {
    min-width: 130px;
    max-width: 173px;

    img {
      width: 70px;
      height: 42px;
    }

    .label {
      font-size: 12px;
    }

    .destaque {
      font-size: 28px;
    }
  }
`;
